import { Banner, Box, Space } from "@dbn/omnichannel-design-system-g4p";
// eslint-disable-next-line no-restricted-imports
import { useEffect, useState } from "react";
import { CustomCard } from "./CustomCard";
// eslint-disable-next-line no-restricted-imports
import {
  RuntimeLocaleKey,
  useFormatMessage,
  useFormatRichMessage2,
} from "../intl";
import { useCommand } from "../useAPI";
import * as ukontoApi from "../UKontoSecondPart/api";
import * as cfApi from "../StandardLoan/api";
import { pipe } from "fp-ts/function";
import { option, taskEither } from "fp-ts";
import { useAppContext } from "../useAppContext";
import { Option } from "fp-ts/Option";
import "./CustomHtml.css";
import { Spinner } from "@g4p/react-styleguide-library";

const foldPackageType: <T>(match: {
  whenBasic: () => T;
  whenMiddle: () => T;
  whenUpper: () => T;
}) => (type: string) => T = match => type => {
  switch (type) {
    case "BASIC":
      return match.whenBasic();
    case "MIDDLE":
      return match.whenMiddle();
    case "UPPER":
      return match.whenUpper();
    default:
      return match.whenBasic();
  }
};

type Props = {
  isFromChild?: boolean;
  physicalCardSelected: Option<boolean>;
  onChange: (data: any) => void;
  isCf?: boolean;
  showMastercard: boolean;
};

export const VirtualCards = (props: Props) => {
  const formatMessage = useFormatMessage();
  const formatRichMessage = useFormatRichMessage2();
  const initVirtualCard = useCommand(
    props.isCf ? cfApi.initVirtualCard : ukontoApi.getPackageType
  );

  const [loading, setLoading] = useState(true);
  const [packageType, setPackageType] = useState("");
  const [physicalCardSelected, setPhysicalCardSelected] = useState(
    option.some(false)
  );

  const {
    config: {
      virtualCardTopImgURL,
      virtualCardMcTopImgURL,
      virtualCardMcMiddleImgURL,
      virtualCardOpenImgURL,
      virtualCardMcOpenImgURL,
      physicalCardTopImgURL,
      physicalCardMcTopImgURL,
      // physicalCardMiddleImgURL,
      physicalCardMcMiddleImgURL,
      physicalCardOpenImgURL,
      physicalCardMcOpenImgURL,
    },
  } = useAppContext();

  const showMastercard = props.showMastercard;

  useEffect(() => {
    pipe(
      initVirtualCard(),
      taskEither.chain(
        (response: {
          packageType: string;
          physicalCardSelected: Option<boolean>;
        }) =>
          taskEither.fromIO(() => {
            setLoading(false);

            response &&
              response?.packageType &&
              setPackageType(response?.packageType);

            response &&
              response?.physicalCardSelected &&
              setPhysicalCardSelected(response?.physicalCardSelected);
          })
      )
    )();
  }, []);

  return (
    <Box column>
      <Spinner show={loading} />
      {/*<ContentRow type="full">*/}
      <CustomCard
        checkBoxValue={option.some(true)}
        checkBoxOnChange={() => {}}
        checkBoxName="virtualCard"
        checkBoxDisabled={true}
        cardTitle={formatMessage("UKonto.MainContent.virtualCardCheckboxTitle")}
        cardDescription={formatMessage(
          "UKonto.MainContent.virtualCardBoxContent"
        )}
        showModalLabel={formatMessage(
          "Ukonto.MainContent.virtualCardBox.MoreInfo"
        )}
        showModalLabelAriaLabel={formatMessage(
          "Ukonto.MainContent.virtualCardBox.MoreInfo.altText"
        )}
        physicalCard={false}
        imageCardHorizontal={showMastercard}
        raiseCard={false}
        imgUrl={pipe(
          packageType,
          foldPackageType({
            whenBasic: () =>
              showMastercard ? virtualCardMcOpenImgURL : virtualCardOpenImgURL,
            whenMiddle: () =>
              showMastercard
                ? virtualCardMcMiddleImgURL
                : virtualCardOpenImgURL,
            whenUpper: () =>
              showMastercard ? virtualCardMcTopImgURL : virtualCardTopImgURL,
          })
        )}
        altTextMessage={formatMessage(
          "VirtualCards.cardType.virtual.mastercard.phoneAndWatch.alt" as RuntimeLocaleKey
        )}
        dialogTitle={formatMessage("UKonto.MainContent.VirtualCardPopupTitle")}
        dialogContent={
          <Box shrink column>
            {formatRichMessage("UKonto.MainContent.VirtualCardPopupContent")}
            <Banner
              title={option.none}
              actions={option.none}
              onDismiss={option.none}
              type="informative"
              content={
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatMessage(
                      "UKonto.MainContent.VirtualCardBannerInfo"
                    ),
                  }}
                />
              }
            />
          </Box>
        }
        tooltipInfoTitle={formatMessage(
          "UKonto.MainContent.VirtualCardTooltipDescriptionTitle"
        )}
        tooltipInfoContent={formatMessage(
          "UKonto.MainContent.VirtualCardTooltipDescription"
        )}
        tooltipButtonAriaLabel={formatMessage(
          "generic.tooltip.infoIcon.ariaLabel"
        )}
        tooltipCloseIconAriaLabel={formatMessage(
          "generic.tooltip.closeIcon.ariaLabel"
        )}
      />
      {/*</ContentRow>*/}
      <Space units={5} />
      {/*<ContentRow type="full">*/}
      <CustomCard
        checkBoxValue={
          props.isCf ? physicalCardSelected : props.physicalCardSelected
        }
        checkBoxOnChange={(data: any) => {
          setPhysicalCardSelected(data.physicalCardSelected);
          props.onChange(data);
        }}
        checkBoxName="physicalCard"
        checkBoxDisabled={props.isFromChild}
        cardTitle={formatMessage(
          "UKonto.MainContent.physicalCardCheckboxTitle"
        )}
        cardDescription={formatRichMessage(
          "UKonto.MainContent.physicalCardBoxContent"
        )}
        showModalLabel={formatMessage(
          "Ukonto.MainContent.physicalCardBox.MoreInfo"
        )}
        showModalLabelAriaLabel={formatMessage(
          "Ukonto.MainContent.physicalCardBox.MoreInfo.altText"
        )}
        physicalCard={true}
        imageCardHorizontal={showMastercard}
        raiseCard={showMastercard}
        imgUrl={pipe(
          packageType,
          foldPackageType({
            whenBasic: () =>
              showMastercard
                ? physicalCardMcOpenImgURL
                : physicalCardOpenImgURL,
            whenMiddle: () =>
              showMastercard
                ? physicalCardMcMiddleImgURL
                : physicalCardOpenImgURL,
            whenUpper: () =>
              showMastercard ? physicalCardMcTopImgURL : physicalCardTopImgURL,
          })
        )}
        altTextMessage={formatMessage(
          "VirtualCards.cardType.plastic.mastercard.alt" as RuntimeLocaleKey
        )}
        dialogTitle={formatMessage("UKonto.MainContent.PhysicalCardPopupTitle")}
        dialogContent={
          <Box shrink column>
            {formatRichMessage("UKonto.MainContent.PhysicalCardPopupContent")}
            <Banner
              title={option.none}
              actions={option.none}
              onDismiss={option.none}
              type="informative"
              content={
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatMessage(
                      "UKonto.MainContent.PhysicalCardBannerInfo"
                    ),
                  }}
                />
              }
            />
          </Box>
        }
      />
      {/*</ContentRow>*/}
    </Box>
  );
};
